// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container__Xswts","topSection":"Sidebar_topSection__2ANmF","linkContainer":"Sidebar_linkContainer__owo6F"};